import axios from 'axios'
import React from 'react'
import { baseUrl } from '../../config/clientsConfig'

const LeadDbBulkHistoryService = {
    getLeadDbBulkHistory: async (body) =>{
        return axios.post(`${baseUrl}/lead/getBulkUploadHistory`, body)

    },
    getBulkUploadLeadData : async (body) =>{
        return axios.post(`${baseUrl}/lead/getBulkUploadLeadData`, body)
    },
    deleteBulkUpload : async (body) =>{
        return axios.post(`${baseUrl}/lead/delete-batch-with-check` , body)
    },
}

export default LeadDbBulkHistoryService